import type { OdoscopeTokenSlot } from '@goldner-group/storefront-odoscope/types'

export type ProductListingDecision = {
  source: 'odoscope' | 'scayle'
  execution: 'client' | 'server'
  tokenSlot?: OdoscopeTokenSlot
  tracking?: 'odoscope' | 'control'
  reason: string
}

export interface DecideProductListingInput {
  isCrawler: boolean
  isDefaultSort: boolean
  // ECOM-2669: the active category carries a manual sort key
  // (`shopLevelCustomData.sortingKey`). Only ever true on the default sort
  // (it is derived from `customSorting`, which is gated on `isDefaultSort`).
  hasCustomSort: boolean
  showOdoscopeExperiment: boolean
}

// Pure source-selection decision, kept free of Nuxt/SDK imports so it can be
// unit-tested directly (the composable that wraps it can't be jest-mounted —
// it depends on useNuxtApp / useExperiments). The custom-sort guard sits ahead
// of both the sort branch and the Odoscope experiment branch, so a curated
// category is served by SAPI even when the experiment is on (ECOM-2669).
export const decideProductListing = ({
  isCrawler,
  isDefaultSort,
  hasCustomSort,
  showOdoscopeExperiment,
}: DecideProductListingInput): ProductListingDecision => {
  if (isCrawler) {
    return { source: 'scayle', execution: 'server', reason: 'crawler' }
  }

  if (hasCustomSort) {
    return {
      source: 'scayle',
      execution: 'client',
      tracking: 'control',
      reason: 'custom-sort',
    }
  }

  if (!isDefaultSort) {
    return {
      source: 'scayle',
      execution: 'client',
      tracking: 'control',
      reason: 'sorting',
    }
  }

  if (!showOdoscopeExperiment) {
    return {
      source: 'scayle',
      execution: 'client',
      tracking: 'control',
      reason: 'mad-default',
    }
  }

  return {
    source: 'odoscope',
    execution: 'client',
    tokenSlot: 'product',
    tracking: 'odoscope',
    reason: 'mad-topseller-experiment',
  }
}
